export function isFromSeoFunnel(query: Record<string, string>) {
  return query.seo !== undefined && query.seo !== 'false';
}
